import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';

const timeMeta = store => next => action => {
	const date = new Date();
	const hasMeta = action.hasOwnProperty('meta');
	if (hasMeta) {
		action.meta['dispatched_at'] = date;
	} else {
		const meta = {
			dispatched_at: date
		};
		action['meta'] = meta;
	}
	return next(action);
};

const store = createStore(
	rootReducer,
	compose(
		applyMiddleware(thunk, timeMeta),
		window.devToolsExtension ? window.devToolsExtension() : f => f
	)
);

export default store;

function middleware(store) {
	return function(next) {
		return function(action) {
			const splittedAction = action.type.split('-');
			const isAPIError =
				splittedAction[splittedAction.length - 1] === 'FAILURE';
			if (isAPIError) {
				store.dispatch({ type: 'ERROR' });
			}
			return next(action);
		};
	};
}



// WEBPACK FOOTER //
// ./src/js/app/store.js